export default {
  "route": {
    "title": "Sistema de publicação de informações",
    "home": "Início",
    "terminal": "Terminal",
    "program": "Programa",
    "h5program": "Programa",
    "my": "Meu",
    "remote_control": "Controle remoto",
    "task_details": "Detalhes da tarefa",
    "add_task": "Adicionar tarefa",
    "program_list": "Lista de programas",
    "terminal_info": "Informações do terminal",
    "add_resolution": "Adicionar resolução",
    "add_program": "Adicionar programa",
    "material_management": "Gestão de materiais",
    "create_program": "Criar programa",
    "login": "Entrar",
    "reset_password": "Redefinir senha",
    "change_password": "Alterar senha",
    "preview": "Pré-visualização"
  },
  append_field:{
    "input_code": "Por favor, insira o código de verificação",
    "code_error": "Erro no código de verificação",
    "fill_code": "Por favor, insira o código de verificação",
    "dOut": "Rotação 3D",
    "dIn": "Rotação 3D",
    "dxiao": "Moldura 3D",
    "selectImage": "Por favor, selecione uma imagem",
    "onlySelectOneImage": "Só pode selecionar uma imagem",
    "imageFormatError": "Erro no formato da imagem",
    "cancel": "Cancelar",
    "selectedNumber": "Selecionado",
    "confirm": "Confirmar",
    "loadinga": "Carregando...",
    "loadingb": "Carregando",
    "uploading": "Carregando",
    "selectStartDates": "Selecione a data de início",
    "selectEndDates": "Selecione a data de término",
    "createTask": "Criar nova tarefa",
    "selectPrograms": "Selecionar programas",
    "createPrograms": "Nuevo",
    "editTask": "Editar tarefa",
    "fillTaskName": "Por favor, insira o nome",
    "selectTaskGroup": "Por favor, selecione o grupo de tarefas",
    "selectProgram": "Por favor, selecione o programa",
    "selected": "Selecionado",
    "programs": "programas",
    "selectDevice": "Por favor, selecione o dispositivo",
    "sendTaskSuccess": "Tarefa enviada com sucesso",
    "taskName": "Nome",
    "playMode": "Modo de reprodução",
    "replaceMode": "Substituição",
    "appendMode": "Adição",
    'apotpatterns': 'Interrupção',
    "dateRange": "Datas de reprodução",
    "timeRange": "Horas de reprodução",
    "taskPeriod": "Dias especificados",
    "mon": "Seg",
    "tue": "Ter",
    "wed": "Qua",
    "thu": "Qui",
    "fri": "Sex",
    "sat": "Sáb",
    "sun": "Dom",
    "back": "Voltar",
    "programList": "Lista de programas",
    "deviceList": "Lista",
    "enterContent": "Por favor, insira o conteúdo",
    "taskGroup": "Grupo de tarefas",
    "selectStartDate": "Selecione a data de início",
    "selectEndDate": "Selecione a data de término",
    "selectStartTime": "Selecione a hora de início",
    "selectEndTime": "Selecione a hora de término",
    "addTask": "Adicionar tarefa",
    "topLeft": "Superior esquerdo",
    "topCenter": "Centro superior",
    "topRight": "Superior direito",
    "leftCenter": "Centro esquerdo",
    "center": "Centro",
    "rightCenter": "Centro direito",
    "bottomLeft": "Inferior esquerdo",
    "bottomCenter": "Centro inferior",
    "bottomRight": "Inferior direito",
    "enterText": "Por favor, insira o texto",
    "fontColor": "Cor da fonte",
    "bgColor": "Cor de fundo",
    "scrollDirection": "Direção de rolagem",
    "scrollSpeed": "Velocidade de rolagem",
    "fontSize": "Tamanho da fonte",
    "alignment": "Alinhamento",
    "subtitle": "Legenda",
    "enterURL": "Por favor, insira a URL",
    "webPage": "Página web",
    "enterMediaURL": "Por favor, insira o endereço de streaming",
    "media": "Streaming",
    "selectVideo": "Por favor, selecione um vídeo",
    unsupportedFormat: 'Formato de arquivo não suportado. Para formatos suportados detalhados, consulte Meu - Ajuda do Sistema.',
    "cancelAllSelections": "Cancele todas as seleções antes de fazer o upload de um novo arquivo",
    "fileName": "Nome do arquivo",
    "fileSize": "Tamanho do arquivo",
    "uploadProgress": "Progresso do upload",
    "cancelUpload": "Cancelar upload",
    "cancelAllUploads": "Cancelar todos os uploads",
    "leftToRights": "Esquerda",
    "rightToLefts": "Direita",
    "bottomToTops": "Cima",
    "static": "Estático",
    "slow": "Lento",
    "medium": "Médio",
    "fast": "Rápido",
    "colorValue": "Valor da cor",
    "defaultEffect": "Efeito padrão",
    "rightToLeft": "Direita",
    "leftToRight": "Esquerda",
    "topToBottom": "Baixo",
    "bottomToTop": "Cima",
    "accordionSqueeze": "Acordeão",
    "zoomInFade": "Zoom in",
    "zoomOutFade": "Zoom out",
    "depthOfField": "Profundidade",
    "leftRightRotate": "Rotação L/D",
    "upDownRotate": "Rotação C/B",
    "counterclockwiseRotate": "Anti-horário",
    "clockwiseRotate": "Horário",
    "upDownZoom": "Zoom V",
    "scaleFade": "Escala",
    "zoomInDisappearing": "Zoom in",
    "transparentFade": "Desvanecimento",
    "gradientScale": "Escala de gradiente",
    "deleteMaterial": "Excluir material",
    "confirmDeleteMaterial": "Confirmar exclusão deste material?",
    "unreviewed": "Não revisado",
    "normal2": "Normal",
    "violating": "Violando",
    "suspectedViolating": "Suspeita de violação",
    "delete": "Excluir",
    "selectMaterial": "Selecione o material",
    "deleteProgramGroup": "Excluir grupo de programa",
    "confirmDeleteGroup": "Confirmar exclusão deste grupo?",
    "add": "Adicionar",
    "toggle_effect": "Alternar efeito",
    "toggle_time": "Alternar tempo",
    "pub_toggle_time": "Alternância",
    "fullscreen": "Tela cheia",
    "normal": "Normal",
    "interactive": "Interativo",
    "main_screen": "Tela principal",
    "sub_screen": "Tela secundária",
    "dual_screen": "Tela dupla",
    "sync_task": "Sincronizar tarefa",
    "normal_mode": "Modo normal",
    "basic_info": "Informações básicas",
    "program_info": "Informações do programa",
    "task_name": "Nome",
    "task_type": "Tipo de tarefa",
    "pub_task": "Tarefa normal",
    "hu_task": "Tarefa interativa",
    "no_data": "Sem dados",
    "no_msg": "Sem informações",
    "program_name": "Nome",
    "program_resolution": "Resolução do programa",
    "program_type": "Tipo de programa",
    "screen_category": "Categoria de tela",
    "edit_program": "Editar programa",
    "edit": "Editar",
    "send": "Enviar",
    "create": "Criar grupo",
    "reload": "Recarregar",
    "name": "Nome",
    "create_task_z": "Criar grupo de tarefas",
    "ps_push_name": "Por favor, insira o nome do grupo",
    "device_list": "Lista de dispositivos",
    "delete_task_group": "Excluir grupo de tarefas",
    "confirm_delete_group": "Confirmar exclusão deste grupo?",
    "delete_success": "Exclusão bem-sucedida",
    "name_cannot_be_empty": "O nome não pode estar vazio",
    "character_length_limit": "O comprimento do caractere deve ser de até 10 caracteres",
    "create_task_success": "Criação de tarefa bem-sucedida",
    "create_task_failed": "Criação falhou",
    "confirm_delete_task": "Você tem certeza que deseja excluir a tarefa?",
    "task_details": "Detalhes da tarefa",
    "download_success": "Download bem-sucedido",
    "waiting_download": "Aguardando download",
    "downloading": "Baixando",
    "confirm_delete": "Você tem certeza que deseja excluir?",
    "confirm_delete_all": "Você tem certeza que deseja excluir tudo?",
    "confirm_delete_selected": "Você tem certeza que deseja excluir a seleção?",
    "no_data_to_clear": "Não há dados para limpar!",
    "refresh": "Atualizar",
    "clear_all": "Limpar tudo",
    "clear_completed": "Concluídos",
    "device_id": "ID",
    "task_size": "Tarefa",
    "speed": "Velocidade",
    "download_progress": "Progresso do download",
    "title": "Título",
    "volume": "Volume",
    "deleteP": "Excluir programa",
    "con_P": "Confirmar exclusão deste programa?",
    "clear": "Limpar",
    "download_status": "Status do download",
    "height_width_cannot_be_empty": "Altura/Largura não pode estar vazio",
    "add_success": "Adição bem-sucedida",
    "enter_number_between_300_to_8000": "Insira um número entre 300 e 8000",
    "width": "Largura",
    "enter_width": "Por favor, insira a largura",
    "height": "Altura",
    "enter_height": "Por favor, insira a altura",
    "confirm_leave_page": "Você tem certeza que deseja sair desta página?",
    "add_content_to_control": "Adicione conteúdo ao controle",
    "add_control": "Adicione controle",
    "save_success": "Salvar com sucesso",
    "save": "Salvar",
    "create_program": "Criar programa",
    "guess": "Você adivinha",
    "modify": "Modificar",
    "text": "Texto",
    "image": "Imagem",
    "background_image": "Imagem de fundo",
    "background_music": "Música de fundo",
    "replace": "Substituir",
    "use_this_template": "Usar este modelo",
    "apply_template": "Aplicar modelo",
    "enter_program_name": "Por favor, insira o nome do programa",
    "program_group": "Grupo de programas",
    "select_program_group": "Selecione o grupo de programas",
    "group_list": "Lista de grupos",
    "preview": "Pré-visualização",
    "my_apps": "Meus aplicativos",
    "template_center": "Centro de templates",
    "home": "Início",
    "source_of_visit": "Fonte da visita",
    "online": "Online",
    "terminal_status": "Status",
    "memory_status": "Status da memória",
    "login": "Entrar",
    "sms_verification": "Verificação por SMS",
    "email_verification": "Verificação por e-mail",
    "log_in": "Fazer login",
    "enter_username": "Insira sua conta",
    "username_cannot_be_empty": "O nome de usuário não pode estar vazio",
    "password_cannot_be_empty": "A senha não pode estar vazia",
    "incorrect_phone_format_for_verification_code": "O formato do número de telefone para o código de verificação está incorreto. Entre em contato com o administrador para corrigir!",
    "incorrect_email_format_for_verification_code": "O formato do e-mail para o código de verificação está incorreto. Entre em contato com o administrador para corrigir!",
    "incorrect_phone_or_email_format_for_verification_code": "O formato do e-mail ou telefone para o código de verificação está incorreto. Entre em contato com o administrador para corrigir!",
    "reset_password": "Redefinir senha",
    "remember_password": "Lembrar senha",
    "register": "Registrar conta",
    "current_version_4.1.6": "V4.1.8",
    "notification_about_network_security": "Notificação sobre segurança da rede",
    "got_it": "Entendi",
    "please_authenticate_for_account_safety": "Para a segurança da sua conta, por favor, autentique-se",
    "enter_account": "Insira sua conta",
    "enter_password": "Insira sua senha",
    "verification_code": "Código de verificação",
    "none": "Nenhum",
    "personal_center": "Centro pessoal",
    "remote_control": "Controle remoto",
    "refresh_success": "Atualização bem-sucedida!",
    "logout": "Sair",
    "confirm_logout": "Tem certeza de que deseja sair?",
    "user_status": "Status do usuário",
    "customer_address": "Endereço do cliente",
    "account_period": "Período da conta",
    "device_control": "Controle remoto do dispositivo",
    "clear_cache": "Limpar cache",
    "exit": "Sair",
    "terminal": "Terminal",
    "program": "Programa",
    "material": "Material",
    "my": "Meu",
    "display_type": "Tipo de exibição",
    "proportion": "Proporção",
    "resolution": "Resolução",
    "screen_orientation": "Orientação da tela",
    "landscape": "Paisagem",
    "portrait": "Retrato",
    "add_resolution": "Adicionar resolução",
    "execute_formatting_when_focus_lost": "Executar formatação ao perder foco",
    "select_resolution": "Selecione a resolução",
    "resolution_list": "Lista de resoluções",
    "confirm_delete_program": "Tem certeza de que deseja excluir o programa?",
    "confirm_delete_this_program": "Tem certeza de que deseja excluir este programa?",
    "bound_tasks_exists_confirm_delete": "Existem tarefas vinculadas, tem certeza de que deseja excluir?",
    "prompt": "Dica",
    "delete_failed": "Falha ao excluir",
    "modification_time": "Hora de modificação",
    "resolution_": "Resolução",
    "associated_tasks": "Tarefas associadas",
    "bound_task": "Tarefa vinculada",
    "program_management": "Gestão de programas",
    "task": "Tarefa",
    "progress": "Progresso",
    "phone_number": "Número de telefone",
    "enter_phone_number": "Insira o número de telefone",
    "password": "Senha",
    "confirm_password": "Confirmar senha",
    "enter_password_again": "Insira a senha novamente",
    "company_name": "Nome da empresa",
    "enter_company_name": "Insira as informações da sua empresa",
    "address": "Endereço",
    "enter_address": "Insira o endereço de contato",
    "username_not_exist": "O nome de usuário não existe",
    "enter_new_password": "Insira uma nova senha",
    "enter_new_password_again": "Insira a nova senha novamente",
    "terminal_management": "Gerenciamento de terminal",
    "delete_group": "Excluir grupo",
    "pel_select_group": "Selecione um grupo",
    "enter_device_name": "Insira o nome do dispositivo",
    "delete_device": "Excluir dispositivo",
    "confirm_delete_device": "Confirmar exclusão deste dispositivo?",
    "terminal_information": "Informação do terminal",
    "qr_code_error": "Erro no código QR",
    "device_not_supported": "Dispositivo não suportado",
    "device_offline": "O dispositivo selecionado deve estar online para enviar comandos, por favor, selecione novamente!",
    "more": "Mais",
    "device_access": "Acesso ao dispositivo",
    "filter": "Filtrar",
    "all": "Todos",
    "offline": "Offline",
    "device_name": "Nome do dispositivo",
    "device_number": "Número do dispositivo",
    "device_group": "Grupo de dispositivos",
    "call_device_please_wait": "Chamando o dispositivo, por favor aguarde...",
    "create_terminal_group": "Criar novo grupo de dispositivos",
    "enter_search_keyword": "Insira a palavra-chave de busca",
    "bind_device": "Vincular dispositivo",
    "select_device_group": "Selecione um grupo de dispositivos",
    "authorized": "Autorizado",
    "unauthorized": "Não autorizado",
    "adjust_volume": "Ajustar volume",
    "reboot_device": "Reiniciar dispositivo",
    "wake_up": "Acordar",
    "sleep": "Suspender",
    "shutdown": "Desligar",
    "clean_up_timing_on_off": "Limpar temporizador",
    "clean_up_disk": "Limpar disco",
    "clean_up_task": "Limpar tarefa",
    "send_command": "Enviar comando",
    "confirm2": "Enviar?",
    "terminal_operation": "Operação do terminal",
    "bind_task": "Informações tarefa",
    "remote_command": "Comando remoto",
    "remote_monitor": "Monitoramento remoto",
    "adding_one_will_override_the_previous": "Somente um registro de tempo pode ser adicionado, o anterior será substituído",
    "screenshot_in_progress_please_wait": "Capturando tela, por favor aguarde",
    "schedule_on_off": "Programar ligar/desligar",
    "shutdown_time": "Desligamento",
    "startup_time": "Inicialização",
    "volume_setting": "Configuração de volume",
    "edit_device_name": "Editar nome do dispositivo",
    "please_select_time": "Por favor, selecione o horário",
    "device_not_online_please_retry": "O dispositivo não está online, por favor tente novamente",
    "sent_successfully": "Enviado com sucesso",
    "version": "V4.1.8",
    "texta": "Texto",
    "userName": "Conta",
    "email": "E-mail",
    "device_memory": "Memória do dispositivo",
    "device": "Dispositivo",
    "device_mac": "MAC do dispositivo",
    "screen_count": "Número de telas",
    "device_location": "Localização do dispositivo",
    "is_authorized": "Está autorizado?",
    "remark": "Observação",
    "device_ip": "IP do dispositivo",
    "system_version": "Versão do sistema",
    "playback_date": "Data de reprodução",
    "playback_period": "Período de reprodução",
    "retrieve_again": "Recuperar novamente",
    "please_enter_password": "Insira uma senha de mais de 8 caracteres que contenha números, letras e caracteres especiais [@#$%^&+=]!",
    "passwords_do_not_match": "As senhas inseridas não coincidem",
    "enter_new_password2": "Insira uma nova senha",
    "current_password_too_simple": "A senha atual é muito simples, por favor, altere sua senha o mais rápido possível, insira caracteres de mais de 8 dígitos que contenham números, letras e caracteres especiais [@#$%^&+=]",
    "creation_time": "Hora de criação",
    "login2": "Entrar",
    "welcome": "Bem-vindo ao login",
    "expired_login": "A autenticação expirou, por favor, faça login novamente.",
    "control": "Controle remoto",
    "add_task": "Adicionar tarefa",
    "program_list": "Lista de programas",
    "terminal_info": "Informação do terminal",
    "add_program": "Adicionar programa",
    "material_management": "Gerenciamento de materiais",
    "change_password": "Alterar senha",
    "enter_text_content": "Insira o conteúdo do texto",
    "hit_the_wall_on_back": "Ao voltar, há uma parede",
    "last_ceremony": "Última cerimônia",
    "already_top_level": "Já está no nível mais alto",
    "already_last_one": "Já é a última vez",
    "white_fox": "Raposa branca",
    "control_img": "Imagem",
    "control_video": "Vídeo",
    "control_streaming": "Streaming",
    "control_webPage": "Página da web",
    "control_subtitle": "Legendas",
    "control_HDMI": "HDMI",
    "control_addbackground": "Fundo",
    "Up": "Carregar",
    "onlyOne": "O controle só pode adicionar um",
    "clearBg": "Limpar fundo",
    "get_code": "Por favor, insira o código de verificação primeiro",
    "del_Null_Program": "Deseja limpar o programa vazio na lista?",
    "please_select_date": "Selecione pelo menos uma data",
    "last_size": "Espaço restante",
    "shutdown_tips": "Não é possível ligar remotamente após desligar",
    "last_size_upload": "Por favor, selecione novamente.",
    "end_date_earlier_than_start_date": "A data de término não pode ser anterior à data de início",
    "account_type": "Tipo de usuário",
    "user_type": "Usuário comum",
    "role_type": "Função",
    "super_administrator": "Superadministrador",
    "term_info_empty": "Informações do terminal estão vazias",
    "select_terminal_prompt": "Clique no botão de lista no canto superior direito para selecionar o terminal",
    "select": "Tudo",
    "data_empty": "Os dados estão vazios!",
    "content_review": "Revisão de conteúdo",
    "start_date": "Data de início",
    "end_date": "Data de término",
    "start_time": "Hora de início",
    "end_time": "Hora de término",
    "select_all": "Tudo",
    "select_group": "Selecionar grupo",
    "review": "Revisar",
    "material_type": "Tipo de material",
    "audio": "Áudio",
    "document": "Documento",
    "material_status": "Estado do material",
    "material_review": "Revisão do material",
    "current_selection_requires_review": "O material selecionado atualmente, precisa de revisão?",
    "invCode": "Código de convite",
    "tip_invitation_empty": "Por favor, insira o código de convite",
    "enter_userName": "Por favor, insira a conta do usuário",
    "enter_email": "Por favor, insira o e-mail",
    "file_less_38": "O arquivo deve ser menor que 1KB",
    "viewError": "Este arquivo não suporta visualização",
    "user": "Informações pessoais",
    "phone_number_too_short": "O comprimento do número de telefone deve ser maior que 9 dígitos",
    "oneImage": "A imagem de fundo já existe, se desejar reenvia-la, primeiro exclua-a",
    "del_title": "Confirmar exclusão",
    "del_message": "Tem certeza de que deseja excluir o controle?",
    "close": "Fechar",
    "exit_group_name": "Editar nome do grupo",
    "group_management": "Grupos",
    "language": "Trocar idioma",
    "mixture": "Mista",
    "date": "Data",
    "weeks": "Semanas",
    "time": "Hora",
    "new_password": "Nova senha",
    "enter_invCode": "Dica: solicite o código de convite ao administrador superior",
    "msg_password": "Dica: insira uma senha com mais de 8 dígitos que contenha números, letras e caracteres especiais [@#$%^&+=]!",
    "oneDoc": "O documento já existe, se desejar reenviá-lo, primeiro exclua-o",
    "Sunday": "Domingo",
    "Monday": "Segunda-feira",
    "Tuesday": "Terça-feira",
    "Wednesday": "Quarta-feira",
    "Thursday": "Quinta-feira",
    "Friday": "Sexta-feira",
    "Saturday": "Sábado",
    "input_error": "Todos os campos do formulário não podem estar vazios",
    video_tutorial:'Material',
    "view": "Assistir online",
    "selectDeviceOne": "Este comando só pode selecionar um dispositivo para consulta",
    "select_device_list": "Lista de dispositivos selecionados",
    "small_size": "Pequeno",
    "medium_size": "Médio",
    "large_size": "Grande",
    device_info:'Informações do dispositivo',
    "notification": "Notificação",
    "notif_title": "Conteúdo da Notificação",
    "notif_msg": "A partir de 5 de novembro de 2024, o Centro de Serviços ETV irá excluir materiais armazenados por mais de um ano. Por favor, esteja ciente e faça backup dos materiais importantes com antecedência. Agradecemos sua compreensão e cooperação.",
    reduce: 'Reduzir',
    bound_material: 'Material Vinculado',
    tip_material: 'O material do programa vinculado não pode ser excluído, por favor, desvincule o material primeiro.',
    boundpo: 'Programa Vinculado',
    bind_progron: 'Este material está vinculado a um programa e não pode ser excluído.',
    index: 'Índice',
    source: 'Fonte',
    getUploadSet_tip: 'Falha ao obter a desativação do upload de material.',
    getUploadstartTime_tip: 'O upload de materiais está proibido no momento. Por favor, faça o upload em horários não proibidos.',
    getUploadendTim: 'Upload de material desativado',
    "download": "Baixar",
    program_review: 'Revisão do programa',
    pass: 'Passar',
    not_passed_or_not_reviewed: 'Não aprovado ou não revisado',
    play_mode: 'Modo de reprodução',
    review_status: 'Status da revisão',
    reject: 'Rejeitar',
    review_content: 'Conteúdo da revisão',
    enter_review_content: 'Por favor, insira o conteúdo da revisão',
    device_quantity: "Quantidade de dispositivos",
    system_help: 'Ajuda do Sistema',
    updateInfo: 'Informações de atualização',
    Formatspecification: 'Especificação de formato',
    fileFormat: 'Formato de arquivo',
    imgFormat: 'Formato de imagem',
    audioFormat: 'Formato de áudio',
    videoFormat: 'Formato de vídeo',
    updated: 'Data de atualização',
    details: '1: Adicionado menu Meu - Ajuda do Sistema<br>2: Novos tipos de material de upload adicionados, upload do Tencent Cloud, sincronização com as configurações do PC<br>3: Otimização da exibição de material e material de programa',
    nameLengthLimit: 'Por favor, limite o comprimento do nome a 50 caracteres',
    "customer_title": "Consulta de conta",
    "authorized_devices": "Dispositivos autorizados",
    "enable": "Ativar",
    "disable": "Desativar",
    "expired": "Conta expirada",
    "valid_date": "Data válida",
    "valid_date_placeholder": "Insira a data válida",
    "capacity_rule": "A capacidade do servidor deve ser múltipla de 100",
    "capacity_label": "Capacidade do servidor (MB)",
    "download_speed": "Limite de velocidade de download",
    "submit_btn": "Enviar",
    "sub_accounts":"Apenas permite modificar subcontas",
    plan_mode: 'Modo de Planejamento',
    default_mode: 'Modo Padrão',
    "noMore": "Não há mais",
    "help": "Ajuda de uso",
    "apk_download": "Download de APK",
    "android": "Android",
    "ios": "iOS",
    "app_name": "Assistente de Publicação de Informações ETV-H5",
    "info_publish": "Publicação de Informações",
    "upload_material": "Carregar Material",
    "img_size": "Exceção de pixel da imagem, por favor verifique e faça o upload.",
    "file_size_exceed_skip": "O tamanho do arquivo no puede exceder",
    "processing": "Processando",
    "failed": "Falhou",
    "aliyun_storage_support": "Armazenamento Aliyun suporta mais formatos",

  },
  vanDialog: {
    confirm: 'Confirmar',
    cancel: 'Cancelar'
  },
  vanPicker: {
    confirm: 'Confirmar',
    cancel: 'Cancelar',
  },
  vanDatetimePicker: {
    title: 'Selecione a data',
  },
}